import theme from "@monorepo/styles/theme";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const PaymentListIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 19 17.2">
    <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_260_200)">
        <path d="M30.94 2H7.4" stroke="#32B88E" strokeWidth="1.98" strokeMiterlimit="10" strokeLinecap="round" />
        <path
          d="M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z"
          fill="#32B88E"
        />
        <path d="M30.94 8.16003H7.4" stroke="#32B88E" strokeWidth="1.98" strokeMiterlimit="10" strokeLinecap="round" />
        <path
          d="M2 10.16C3.10457 10.16 4 9.2646 4 8.16003C4 7.05546 3.10457 6.16003 2 6.16003C0.89543 6.16003 0 7.05546 0 8.16003C0 9.2646 0.89543 10.16 2 10.16Z"
          fill="#32B88E"
        />
        <path d="M30.94 14.3101H7.4" stroke="#32B88E" strokeWidth="1.98" strokeMiterlimit="10" strokeLinecap="round" />
        <path
          d="M2 16.3101C3.10457 16.3101 4 15.4146 4 14.3101C4 13.2055 3.10457 12.3101 2 12.3101C0.89543 12.3101 0 13.2055 0 14.3101C0 15.4146 0.89543 16.3101 2 16.3101Z"
          fill="#32B88E"
        />
        <path d="M30.94 20.47H7.4" stroke="#32B88E" strokeWidth="1.98" strokeMiterlimit="10" strokeLinecap="round" />
        <path
          d="M2 22.47C3.10457 22.47 4 21.5745 4 20.47C4 19.3654 3.10457 18.47 2 18.47C0.89543 18.47 0 19.3654 0 20.47C0 21.5745 0.89543 22.47 2 22.47Z"
          fill="#32B88E"
        />
      </g>
      <defs>
        <clipPath id="clip0_260_200">
          <rect width="31.93" height="22.47" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);
